// promos

window.addEventListener('DOMContentLoaded', handlePromos)

function isPromoLive(promo) {
  const { start_time, end_time } = promo
  const now = new Date()
  const start = new Date(start_time)
  const end = new Date(end_time)
  return now >= start && now <= end
}

function isPromoForLocale(promo, locale) {
  const { included_countries, excluded_countries } = promo

  let isIncludedCountry = true
  if (included_countries) {
    isIncludedCountry = false
    const includedCountriesArray = included_countries.split(',')
    for (const country of includedCountriesArray) {
      if (country.trim() === locale) {
        isIncludedCountry = true
        break
      }
    }
  }

  let isNotExcludedCountry = true
  if (excluded_countries) {
    const excludedCountriesArray = excluded_countries.split(',')
    for (const country of excludedCountriesArray) {
      if (country.trim() === locale) {
        isNotExcludedCountry = false
        break
      }
    }
  }

  const isValidCountry = isIncludedCountry && isNotExcludedCountry
  return isValidCountry
}

function isExpired(future) {
  const end = new Date(future)
  if (Number.isNaN(end)) throw new Error('Invalid date')

  let diff = end - Date.now() // ms remaining
  return diff <= 0 // already expired
}

function getCountdown(future) {
  const end = new Date(future)
  if (Number.isNaN(end)) throw new Error('Invalid date')

  let diff = end - Date.now() // ms remaining
  if (diff <= 0) return null // already expired

  const MS_SEC = 1_000
  const MS_MIN = 60 * MS_SEC
  const MS_HOUR = 60 * MS_MIN
  const MS_DAY = 24 * MS_HOUR

  const days = Math.floor(diff / MS_DAY)
  diff %= MS_DAY
  const hours = Math.floor(diff / MS_HOUR)
  diff %= MS_HOUR
  const minutes = Math.floor(diff / MS_MIN)
  diff %= MS_MIN
  const seconds = Math.floor(diff / MS_SEC)

  const totalHours = days * 24 + hours
  return `<span class="countdown-text">${totalHours > 0 ? `${String(totalHours).padStart(2, '0')}:` : ''}${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}</span>`
}

function handlePromos() {
  const contextScript = document.querySelector('#global-context-json')
  const context = contextScript ? JSON.parse(contextScript.textContent) : null

  if (context) {
    const isoCode = context.localization_country.iso_code
    const promoData = processPromos(context.active_promos, isoCode)
    updateCountdown(promoData, isoCode === 'US')
  }

  function processPromos(promos, locale) {
    if (!promos?.length) return null

    const promosForLocale = promos.filter((promo) => isPromoForLocale(promo, locale))
    if (!promosForLocale.length) return null
    const livePromo = promosForLocale.find((promo) => isPromoLive(promo))
    if (!livePromo) return null

    // Extract promo data
    const {
      discount_type = 'percentage',
      percentage_discount,
      product_eligibility = 'sitewide',
      static_discount_code,
    } = livePromo

    // Product eligibility checks
    let isValidProduct = false
    if (product_eligibility?.toLowerCase() === 'sitewide') {
      isValidProduct = true
      // additional product eligibility checks here
    }

    // Static discount code checks
    const hasStaticDiscountCode = Boolean(static_discount_code)

    // Final promo validation
    const isValidPromo = isValidProduct && hasStaticDiscountCode

    // Text formatting
    let offerButtonText = 'CLAIM OFFER'
    if (isValidPromo) {
      offerButtonText = static_discount_code
    }

    let discountText = ''
    if (isValidPromo && discount_type?.toLowerCase() === 'percentage' && percentage_discount) {
      discountText = `Get ${percentage_discount}% off with code:`
    }

    return {
      isValidPromo,
      discountText,
      offerButtonText,
      saleStart: livePromo?.start_time,
      saleEnd: livePromo?.end_time,
      holidayName: livePromo?.holiday_name,
      holidayCutoff: livePromo?.holiday_cutoff_time,
      holidayPriorityCutoff: livePromo?.holiday_priority_cutoff_time,
      countdownHours: livePromo?.countdown_hours || 72,
    }
  }

  function updateCountdown(promoData, isUS) {
    if (!promoData) return
    if (!promoData.isValidPromo) return

    const { holidayName, holidayCutoff, holidayPriorityCutoff, saleEnd, countdownHours } = promoData

    let timer = null
    const wrapperEl = document.querySelector('.liquid-pdp__shipping-cutoff-wrapper')
    const textEl = document.querySelector('.liquid-pdp__shipping-cutoff-text')
    const countdownEl = document.querySelector('.liquid-pdp__shipping-cutoff-countdown')
    const disclaimerEl = document.querySelector('.liquid-pdp__shipping-cutoff-disclaimer')
    const elementsFound = !!wrapperEl && !!textEl && !!countdownEl && !!disclaimerEl

    // Holiday cutoff timer
    if (isUS && holidayCutoff && elementsFound && !isExpired(holidayCutoff)) {
      wrapperEl.classList.remove('hide')
      textEl.innerHTML = `<span style='font-weight: bold;'>Time is running out</span> to get it by ${holidayName}*`
      disclaimerEl.innerHTML = '* Within the contiguous US'

      const tickParams = { cutoff: holidayCutoff, isPriority: false }

      tick(tickParams)
      timer = setInterval(() => tick(tickParams), 1000)
      return
    }

    // Holiday priority cutoff timer
    if (isUS && holidayPriorityCutoff && elementsFound && !isExpired(holidayPriorityCutoff)) {
      wrapperEl.classList.remove('hide')
      textEl.innerHTML = `<span style='font-weight: bold;'>Time is running out</span> to get it by ${holidayName}*`
      disclaimerEl.innerHTML = '* Within the contiguous US'
      const tickParams = { cutoff: holidayPriorityCutoff, isPriority: true }
      tick(tickParams)
      timer = setInterval(() => tick(tickParams), 1000)
      return
    }

    const timeLeft = new Date(saleEnd) - Date.now()
    const isLastChance = timeLeft <= countdownHours * 60 * 60 * 1000

    // Sale end timer
    if (elementsFound && !isExpired(saleEnd) && isLastChance) {
      wrapperEl.classList.remove('hide')
      textEl.innerHTML = `<span style='font-weight: bold;'>ENDING SOON!</span>`
      const tickParams = { cutoff: saleEnd, isPriority: false, isLastChance: true, holidayName }
      tick(tickParams)
      timer = setInterval(() => tick(tickParams), 1000)
      return
    }

    function tick(params) {
      const { cutoff, isPriority, isLastChance, holidayName } = params

      const countdownText = getCountdown(cutoff)

      const orderText = isLastChance
        ? `${holidayName} Sale ends in`
        : isPriority
          ? 'Order with Priority Shipping in the next'
          : 'Order in the next'

      if (countdownText) {
        countdownEl.innerHTML = `${orderText} ${countdownText}`
        // Check if less than 24 hours remaining
        const end = new Date(cutoff)
        const now = new Date()
        const hoursRemaining = (end - now) / (1000 * 60 * 60)
        textEl.innerHTML = `<span style='font-weight: bold;'>${hoursRemaining <= 24 ? 'ENDING TONIGHT!' : 'ENDING SOON!'}</span>`
      } else {
        textEl.innerHTML = ''
        countdownEl.innerHTML = ''
        disclaimerEl.innerHTML = ''
        wrapperEl.classList.add('hide')
        clearInterval(timer) // stop once past cutoff
      }
    }
  }
}
